import ajax from 'libraries/ajax'
import main from 'main'
import $ from 'jquery'

class base
{
  processing = false

  toggle(element)
  {
    if($(element).hasClass('open'))
      this.close(element)
    else
      this.open(element)
  }

  open(element)
  {
    $(element).toggleClass('open', true)
  }

  close(element)
  {
    $(element).toggleClass('open', false)
  }

  runCallbacks(eventName, callbackParams, callbackFunction)
  {
    if(typeof this.params.events === 'object' && typeof this.params.events[eventName] === 'object')
      for(let callback of this.params.events[eventName])
        callback(callbackParams)

    if(typeof callbackFunction === 'function')
      callbackFunction(callbackParams)
  }

  runQuery(params)
  {
    if(this.processing)
      return

    this.processing = true
    if(params.element)
    {
      $(params.element).toggleClass('processing', true)
      $(params.element).find('.message').remove()
      this.toggleSubmitButtonText(params.element)
    }

    let requestLength = 0
    if(typeof params.input !== 'undefined' && typeof params.input.entries === 'function')
    {
      for(let entry of params.input.entries())
      {
        if(typeof entry[1] === 'string')
          requestLength += entry[1].length
        else
          requestLength += entry[1].size
      }
    }

    if(requestLength > 0 && requestLength > main.framework.application.postMaxSize)
    {
      this.insertErrorMessage(main.framework.dict.ajax.defaultResponseRequestTooLarge, params)
      this.processing = false
      $(params.element).toggleClass('processing', false)
    }

    else
    {
      let query = new ajax.query(params)
      query.run(() =>
      {
        this.processing = false

        if(!params.element)
          return

        $(params.element).toggleClass('processing', false)
        this.toggleSubmitButtonText(params.element)

        if(!query.status)
        {
          let errorMessage = query.getMessage()
          if(errorMessage)
            this.insertErrorMessage(errorMessage, params)

          if(query.response && query.response.messages)
          {
            for(let message of query.response.messages)
            {
              if(message.type !== 'inputError')
                continue

              let input = $(params.element).find('[name="'+ message.data.field +'"]').get(0)
              if(!input)
              {
                let match = message.data.field.match(new RegExp('(.*)(\\[/\\^\\[0-9\]\\+\\$/\])$'))
                if(match && match[1])
                  input = $(params.element).find('[name="'+ match[1] +'[]"]').get(0)
              }

              if(!input)
                continue

              let messageElement = $('<div class="message input-error">'+ message.message +'</div>').get(0)
              let optionsElement = $(input).closest('.options').get(0)

              if(optionsElement)
                $(messageElement).insertAfter(optionsElement)
              else
                $(messageElement).insertAfter(input)
            }
          }
        }
      })
    }
  }

  toggleSubmitButtonText(formElement)
  {
    const submitButton = $(formElement).find('input[type=submit]').get(0)
    if(!submitButton)
      return

    if(this.processing)
      $(submitButton).attr('value', main.framework.dict.application.formSubmitInProgress)

    else
      $(submitButton).attr('value', main.framework.dict.application.formSubmit)
  }

  insertErrorMessage(message, params)
  {
    let errorElement = $('<div class="message error">'+ message +'</div>').get(0)

    if(params.errorsBefore)
      $(errorElement).insertBefore(params.errorsBefore)
    else if(params.errorsAfter)
      $(errorElement).insertAfter(params.errorsAfter)
    else
    {
      let form = $(params.element).closest('form').get(0)
      let submitButton = null
      if(form)
        submitButton = $(params.element).find('input[type="submit"]').get(0)

      if(submitButton)
        $(errorElement).insertBefore(submitButton)
      else
        $(errorElement).insertAfter(params.element)
    }
  }
}

export default base



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/base.js